const styles = theme => ({
    dialog: {
        textAlign: "start",
    }
});

export default styles;
